import { createStore, combineReducers, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

export function createReduxStore({reducers = {}, initialState = undefined}) {
  const middlewares = [thunk];
  
  // Replace __CLIENT__ and __DEV__ with process.env.NODE_ENV check
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
  }

  return createStore(
    combineReducers({...reducers}),
    initialState,
    applyMiddleware(...middlewares),
  );
}

export default createReduxStore;